import { render, staticRenderFns } from "./MspGraficoAndatureSemplice.vue?vue&type=template&id=36e8581a"
import script from "./MspGraficoAndatureSemplice.vue?vue&type=script&lang=js"
export * from "./MspGraficoAndatureSemplice.vue?vue&type=script&lang=js"
import style0 from "./MspGraficoAndatureSemplice.vue?vue&type=style&index=0&id=36e8581a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports